import { Routes } from "@ctypes";

export const ONBOARDING_ROUTES = [
  Routes.PhoneNumber,
  Routes.PhoneVerification,
  Routes.Name,
  Routes.ResidentialAddress,
  Routes.ResidentialAddressConfirmation,
  Routes.Citizenship,
  Routes.Ssn,
  Routes.InvestmentPriority,
  Routes.InvestmentDownturnReaction,
  Routes.Employment,
  Routes.EmployerAddress,
  Routes.EmployerAddressAutofill,
  Routes.EmployerAddressConfirmation,
  Routes.AddBeneficiaryType,
  Routes.AddChild,
  Routes.GoalType,
  Routes.GoalName,
  Routes.TrumpAccountCheck,
  Routes.TrumpSidecarIntroduction,
  Routes.TrumpSidecarCurrentContribution,
  Routes.TrumpSidecarTaxCalculation,
  Routes.TrumpSidecarRecommendedContribution,
  Routes.AccountType,
  Routes.GoalDeposit,
  Routes.ChildDeposit,
  Routes.BankLinking,
];
